/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

function getSubscriptionVariantId(kitVariantId) {
  const result = allvariants.find(pair => pair.kitvariantid === kitVariantId);
  return result ? result.subscriptionvariantid : null;
}
function getSelectedKitVariantId() {
  const selectedRadio = document.querySelector('input.radio-input[type="radio"]:checked');
  if (!selectedRadio) return null;
  const radioId = selectedRadio.id;
  const label = document.querySelector(`label[for="${radioId}"]`);
  return label ? label.id : null;
}
function initDeliverySelectToggle() {
  const deliverySelect = document.querySelector(".option_cstm_delivery");
  const subscribeRadios = document.querySelectorAll(
    'input[type="radio"][name="subscribe-options"]'
  );
  if (!deliverySelect || subscribeRadios.length === 0) return;
  
  deliverySelect.disabled = true;
  
  subscribeRadios.forEach(function (radio) {
    radio.addEventListener("change", function () {
      const selectedValue = this.value; // either 'one_time' or 'subscribe_save'
      console.log("Selected Plan:", selectedValue);
      if (selectedValue == "2") {
        deliverySelect.disabled = false;
      } else {
        deliverySelect.disabled = true;
      }
    });
  });
}

function initDuplicateButton() 
{
  document.addEventListener("click", function (event) {
    const selectedRadio = document.querySelector(
      'input[type="radio"][name="subscribe-options"]:checked'
    );
    const selectedPlan = selectedRadio ? selectedRadio.value : null;
    const duplicateBtn = event.target.closest("#duplicate_button");
    if (!duplicateBtn) return;
    const quantityInput = document.querySelector(
      '.quantity__input[name="quantity"][type="number"]'
    );
    const quantity = quantityInput ? quantityInput.value : null;
    if (selectedPlan == "1") 
    {
      document.getElementById("original_button")?.click();
    } else if (selectedPlan == "2") 
    {
      const deliverySelect = document.querySelector(".option_cstm_delivery");
      const sellingPlanId = deliverySelect ? deliverySelect.value : "";
      const kitvariantid = getSelectedKitVariantId();
      const subVariantId = getSubscriptionVariantId(kitvariantid);

      console.log(sellingPlanId,subVariantId);
      
      if (!sellingPlanId || !subVariantId) {
        alert("Please select a delivery frequency and subscription variant.");
        return;
      }
      
      const lineItems = [
        { quantity, id: subVariantId, selling_plan: sellingPlanId },
      ];

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: lineItems }),
      })
        .then((res) => {
          if (!res.ok) throw new Error(`Request failed: ${res.status}`);
          return res.json();
        })
        .then((data) => {
          console.log("Products added:", data);
          document.getElementById("original_button")?.click();
        })
        .catch((err) => {
          console.error("Error adding items:", err);
          alert("Failed to add items.");
        });
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initDeliverySelectToggle();
  initDuplicateButton();
});
document.addEventListener("shopify:section:load", function (event) {
  initDeliverySelectToggle();
  initDuplicateButton();
});

// AMA -- variant on pre-order metafield
var buttonTextSpan = document.querySelector('.product__submit__item button span.btn__text');  
const variantData = JSON.parse(document.getElementById('variant-metafields-json').textContent);
const preOrderStatement = document.getElementById('pre_order_statement');
console.log(variantData);

document.addEventListener('theme:variant:change', function(event) {
  const variantId = event.detail.variant.id.toString();
  const data = variantData[variantId] || {};
  const preorderInputId = 'preorder';

  // Find all forms with action="/cart/add"
  const forms = document.querySelectorAll('form[action="/cart/add"]');

  forms.forEach(form => {
    // Remove existing preorder input if present
    const oldInput = form.querySelector(`#${preorderInputId}`);
    if (oldInput) oldInput.remove();

    if (data["preorder"] === "true") {
      // Create and append hidden preorder input
      const preorderInput = document.createElement('input');
      preorderInput.type = 'hidden';
      preorderInput.name = 'properties[Pre-Order]';
      preorderInput.value = '-';
      preorderInput.id = preorderInputId;

      form.appendChild(preorderInput);
    }
  });

  if (data["preorder"] === "true") {
    console.log("variant on pre-order");
    if (buttonTextSpan) buttonTextSpan.textContent = 'Pre-Order';
    if (preOrderStatement) preOrderStatement.style.display = 'block';
  } else {
    console.log("variant not pre-order");
    if (buttonTextSpan) buttonTextSpan.textContent = 'Add to Cart';
    if (preOrderStatement) preOrderStatement.style.display = 'none';
  }
});




